export default __webpack_public_path__ + "f13d9da25cb12ff4fb49a440562e40e7.png";